import axiosInstance from './axios';

export interface Payment {
    id: string;
    total: number;
    metodoPago: 'EFECTIVO' | 'TARJETA' | 'TRANSFERENCIA';
    createdAt: string;
    boleto?: string;
    vehiculo?: {
        placa: string;
    };
}

export const getPaymentsHistory = async (): Promise<Payment[]> => {
    const response = await axiosInstance.get<Payment[]>('/payments');
    return response.data;
};
